import React, { useState } from 'react';
import { Resizable, ResizableProps } from 'react-resizable';

export interface ResizeableTitleProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
  onResize: ResizableProps['onResize'];
  width: ResizableProps['width'];
}

function ResizeableTitle(props: ResizeableTitleProps) {
  const { onResize, width, onClick, ...restProps } = props;

  /**
   * Sorting with resize
   * @see https://github.com/ant-design/ant-design/issues/14647#issuecomment-467865540
   */
  const [resizing, setResizing] = useState(false);

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      onResize={onResize}
      onResizeStart={() => setResizing(true)}
      onResizeStop={() => setTimeout(() => setResizing(false))}
      draggableOpts={{ enableUserSelectHack: false }}
      handle={
        // eslint-disable-next-line
        <span
          className="column-resize-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
    >
      <th {...restProps} onClick={(e) => !resizing && onClick?.(e)} />
    </Resizable>
  );
}

export default ResizeableTitle;
